// extracted by mini-css-extract-plugin
export default {"container":"VkfErM","registrationButtonSpacing":"ENgDsK","registrationButtonSpacing--noImage":"RPTR3a","registrationButtonSpacingNoImage":"RPTR3a"};